export const frontmatter = {
    "draft": false,
    "title": "Generador de vectores",
    "description": "Generación de embeddings y vectores para las colecciones de la base de conocimiento en OnnIA.",
    "sidebar_label": "Generador de vectores",
    "sidebar_group": "referencia",
    "sidebar_order": 2
}

export const toc = []